import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughIntegrationProps = {
  node: ConversationFlowAuditLogEntry<
    | 'EMAIL_EXTERNAL_INTEGRATION_NODE_VISITED'
    | 'TELEPHONY_EXTERNAL_INTEGRATION_NODE_VISITED'
    | 'MESSENGER_EXTERNAL_INTEGRATION_NODE_VISITED'
  >;
};

export function RoutedThroughIntegration({
  node,
}: RoutedThroughIntegrationProps): JSX.Element {
  return (
    <>
      Integration <strong>{node.http_request_type}</strong> ·{' '}
      {node.variables?.length ? (
        <>
          Variables <strong>{node.variables.join(', ')}</strong>
        </>
      ) : (
        'No variables created'
      )}
    </>
  );
}
